import createStyles from '@material-ui/core/styles/createStyles';
import {WithStyles} from '@material-ui/core/styles/withStyles';

export const styles = () =>
  createStyles({
    root: {
      position: 'absolute',
      bottom: 0,
      width: '100%',
      top: 0,
      zIndex: 1,
    },
  });

export type Styles = WithStyles<typeof styles>;
